import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CgMaximize as ExpandIcon, CgMinimize as ReduceIcon } from 'react-icons/cg';
import { AiOutlineMenu as BarsIcon } from 'react-icons/ai';
import { CSSTransition } from 'react-transition-group';
import './ComposerAddons.css';
import CustomExpandIcon from './CustomExpandIcon';
import CustomMinimizeIcon from './CustomMinimizeIcon';

const goToMenu = (menuLabel) => {
  window.store.sendMessage(menuLabel);
};

function DropdownMenu(props) {
  const [menuHeight, setMenuHeight] = useState(null);
  const dropdownRef = useRef(null);
  const { language } = props;
  const menuItems = language === 'es' ? ['Reiniciar'] : ['Start over'];

  useEffect(() => {
    setMenuHeight(dropdownRef.current?.firstChild.offsetHeight);
  }, []);

  function calcHeight(el) {
    const height = el.offsetHeight;
    setMenuHeight(height);
  }

  function onKeyPressed(callback) {
    return (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        callback();
      }
    };
  }

  function DropdownItem({ children, goToMenu, ...rest }) {
    return (
      <button
        className="menu-item"
        onClick={() => {
          goToMenu();
          props.toggleDropdown();
        }}
        onKeyDown={onKeyPressed(() => {
          goToMenu();
          props.toggleDropdown();
        })}
        {...rest}
      >
        {children}
        <span className="icon-right">{rest.rightIcon}</span>
      </button>
    );
  }

  return (
    <div className="dropdown" style={{ height: menuHeight }} ref={dropdownRef}>
      <CSSTransition in timeout={500} classNames="menu-primary" unmountOnExit onEnter={calcHeight}>
        <div className="menu">
          {menuItems.map((item) => (
            <DropdownItem key={item} goToMenu={() => goToMenu(item)}>
              {item}
            </DropdownItem>
          ))}
        </div>
      </CSSTransition>
    </div>
  );
}

DropdownMenu.propTypes = {
  language: PropTypes.string.isRequired,
  toggleDropdown: PropTypes.func.isRequired,
};

class ComposerAddonsLocal extends React.Component {
  state = {
    maximized: false,
    showDropdown: false,
    statusMessage: ''
  };

  toggleMaximize = () => {
    if (this.state.maximized) {
      document.getElementsByClassName('bpw-layout')[0].style.height = '80%';
      window.top.postMessage('unmaximize', '*');
      this.setState({ maximized: false, statusMessage: 'Window resized to normal' });
    } else {
      document.getElementsByClassName('bpw-layout')[0].style.height = '100%';
      window.top.postMessage('maximize', '*');
      this.setState({ maximized: true, statusMessage: 'Window maximized' });
    }
  };

  toggleDropdown = () => {
    this.setState({ showDropdown: !this.state.showDropdown });
  };

  onKeyPressed = (callback) => {
    return (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        callback();
      }
    };
  };

  render() {
    const { preferredLanguage } = this.props.store;
    const botId = this.props.store.config.botId
    const botIdMapping = {
      totalbyverizon: ['totalbyverizon', 'tbv'],
      //simplemobile: ['simplemobile', 'sm_'],
    };

    const isTWorSM = Object.values(botIdMapping).some(ids => ids.some(id => botId.includes(id)));

    return (
      <div>
        <button
          className="icon-button icon-button-left"
          onClick={this.toggleDropdown}
          onKeyDown={this.onKeyPressed(this.toggleDropdown)}
          aria-label="Open menu"
        >
          <BarsIcon />
        </button>
        {this.state.showDropdown && (
          <DropdownMenu goToMenu={goToMenu} toggleDropdown={this.toggleDropdown} language={preferredLanguage} />
        )}
        <button
          id="btn-maximize"
          className="icon-button icon-button-right"
          onClick={this.toggleMaximize}
          onKeyDown={this.onKeyPressed(this.toggleMaximize)}
          aria-label="Resize window button"
        >
         {this.state.maximized ? (isTWorSM ? <CustomMinimizeIcon /> : <ReduceIcon />) : (isTWorSM ? <CustomExpandIcon /> : <ExpandIcon />)}
        </button>
        {/* ARIA live region */}
        <div aria-live="polite" aria-atomic="true" style={{ position: 'absolute', left: '-9999px' }}>
          {this.state.statusMessage}
        </div>
      </div>
    );
  }
}

ComposerAddonsLocal.propTypes = {
  store: PropTypes.shape({
    preferredLanguage: PropTypes.string.isRequired,
    intl: PropTypes.shape({
      defaultLocale: PropTypes.string
    }).isRequired
  }).isRequired
};

export { ComposerAddonsLocal as ComposerAddons };
